import { Box } from "@mui/material";
import commonStyles from "../../../styles/common.module.css";
import SelectComponent from "../document/secondary/Select";
import { ReactNode } from "react";
interface Props {
  header: string;
  description: string;
  images?: string[];
  isSelectRequired?: boolean;
  selected?: string;
  setSelected?: React.Dispatch<React.SetStateAction<string>>;
  selectLabel?: string;
  options?: {
    value: string;
    label: string;
  }[];
  tips: string[];
  tipHeader: ReactNode;
  buttonLabel: string;
  onClick: () => void;
}

const Instruction = ({
  header,
  description,
  images,
  tips,
  buttonLabel,
  onClick,
  isSelectRequired = false,
  selected = "",
  setSelected,
  options,
  selectLabel,
  tipHeader,
}: Props) => {
  return (
    <>
      <h1 className={commonStyles.header}>{header}</h1>
      <h2 className={commonStyles.description}>{description}</h2>
      <Box>
        {images?.map((src, index) => (
          <img
            key={index}
            src={src}
            alt={`Instruction step ${index + 1}`}
            className={
              commonStyles.instructionImages
            }
          />
        ))}
      </Box>
      <Box
        textAlign="left"
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        mb={2}
      >
        <ul>{tipHeader}
          {tips.map((tip, index) => (
            <li key={index}>
              <span className={commonStyles.tip}>{tip}</span>
            </li>
          ))}
        </ul>
      </Box>
      {isSelectRequired && setSelected && options && selectLabel && (
        <SelectComponent
          label={selectLabel}
          options={options}
          selectedValue={selected}
          onChange={setSelected}
        />
      )}

      <button
        className={`${isSelectRequired ? (selected != "" ? commonStyles.button_primary : commonStyles.button_primary_disabled) : commonStyles.button_primary}`}
        onClick={() => {
          if (!isSelectRequired || (isSelectRequired && selected != "")) {
            onClick();
          }
        }}
      >
        {buttonLabel}
      </button>
    </>
  );
};

export default Instruction;
